import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import EditSoftwareForm from "../Forms/EditSoftwareForm";
import { ForensicSoftware } from "@/types";

interface EditSoftwareModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  defaultInfo: ForensicSoftware;
}

export const EditSoftwareModal: FC<EditSoftwareModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.(); // Refetch queries in software section
    handleClose();
  };

  const handleClose = () => {
    onClose?.();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <EditSoftwareForm
        width={550}
        defaultFormData={defaultInfo}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};
